import React from 'react'
import "./footer.scss"

export default function Footer() {
  return (
    <div>
      
    </div>
  )
}
